export default __webpack_public_path__ + "static/media/hnk-theatre.8808b9d0.jpeg";